import axios from '@/utils/axios'
// 添加追剧列表
export function listRecharge(query) {
    return axios({
        url: '/video/recharge/getRechargeList',
        method: 'get',
        params: query
    })
}
// 详情
export function details(query) {
    return axios({
        url: '/video/recharge/edit/infoOrRefund',
        method: 'get',
        params: query
    })
}
// 删除
export function del(query) {
    return axios({
        url: '/video/recharge/del/save',
        method: 'post',
        params: query
    })
}
// 退款
export function refund(query) {
    return axios({
        url: '/video/recharge/refund/save',
        method: 'post',
        params: query
    })
}
// 导出
// export function exportExcl(query) {
//     return axios({
//         url: '/video/recharge/export',
//         method: 'get',
//         params: query
//     })
// }
